import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string, array } from "yup";
import { BatchRecordingFormValues } from "src/models/BatchRecording.model";
import BatchRecordingForm from "../Layouts/BatchRecordingForm";
import moment from "moment";
import { useAddRecordingMutation } from "src/services/BatchServices";
import { useParams } from "react-router-dom";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddBatchRecordingFormWrapper = ({ onClose }: Props) => {
  const { batchId } = useParams();

  const [addRecording] = useAddRecordingMutation();

  // Form Initial Values
  const initialValues: BatchRecordingFormValues = {
    date: "",
    description: "",
    fileUrl: [
      {
        fileName: "",
      },
    ],
    recordings: [
      {
        title: "",
        url: "",
        isShowRecording: false,
      },
    ],
  };

  // Validation Schema
  const validationSchema = object().shape({
    date: string().required("date is required"),
    fileUrl: array().of(
      object({
        fileName: string().required("file is required"),
      })
    ),
    recordings: array().of(
      object({
        title: string().required("title is required"),
        url: string().required("url is required"),
      })
    ),
  });

  // Handle Submit
  const handleSubmit = (
    values: BatchRecordingFormValues,
    { setSubmitting, resetForm }: FormikHelpers<BatchRecordingFormValues>
  ) => {
    const formattedValues = {
      batchId: batchId,
      date: moment(values?.date).format("yyyy-MM-DD"),
      description: values?.description,
      fileUrl: values?.fileUrl?.map((el: any) => el["fileName"]),
      recordings: values?.recordings?.map((el: any) => {
        return {
          title: el?.title,
          url: el?.url,
        };
      }),
    };

    addRecording(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          onClose();
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="lg" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <BatchRecordingForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddBatchRecordingFormWrapper;
